import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { AdministrationModel } from '../../../../models/administration.model'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MatDatepicker, MatSnackBar } from '@angular/material'
import { DocumentsService } from '../../../../services/documents.service'
import * as moment from 'moment'
import { ZipDownload } from '../../../../models/zip-download'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-administration-documents-download',
  templateUrl: './administration-documents-download.component.html',
  styleUrls: ['./administration-documents-download.component.scss'],
})
export class AdministrationDocumentsDownloadComponent implements OnInit {
  @Input() administration: AdministrationModel
  @ViewChild('start_date_picker') startDatePicker: MatDatepicker<any>
  @ViewChild('end_date_picker') endDatePicker: MatDatepicker<any>
  downloadForm: FormGroup
  downloading = false
  downloadingAll = false

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private documentsService: DocumentsService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.downloadForm = this.formBuilder.group({
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
    })
  }

  downloadAllDocuments(): void {
    this.downloadForm.get('start_date').setValue('01-01-2016')
    this.downloadForm.get('end_date').setValue(moment().format('DD-MM-YYYY'))

    this.downloadDocuments(true)
  }

  downloadDocuments(all = false): void {
    if (!all && !this.downloadForm.valid) {
      return
    }

    all ? (this.downloadingAll = true) : (this.downloading = true)

    // Get appropriate data for request
    const administrationId = this.administration.id,
      startDate = all ? '2017-01-01' : moment(this.downloadForm.get('start_date').value).format('YYYY-MM-DD'),
      endDate = all
        ? moment().format('YYYY-MM-DD')
        : moment(this.downloadForm.get('end_date').value).format('YYYY-MM-DD')

    // Download for selected period and handle
    this.documentsService.downloadMultiple(administrationId, startDate, endDate).subscribe(
      (response: ZipDownload) => {
        all ? (this.downloadingAll = false) : (this.downloading = false)

        if (!response || response.body.byteLength === 0) {
          this.translateService.get('ADMIN.DOWNLOAD.NO_FILES', {}).subscribe((message: string) => {
            this.openSnackBar(message)
          })

          return
        }

        this.handleDownload(response)
      },
      err => {
        console.error(err)
        all ? (this.downloadingAll = false) : (this.downloading = false)

        if (err && err.message) {
          this.openSnackBar(err.message)
        } else {
          this.translateService.get('ADMIN.DOWNLOAD.ERROR', {}).subscribe((message: string) => {
            this.openSnackBar(message)
          })
        }
      },
    )
  }

  private get window(): any {
    return <any>window
  }

  private openSnackBar(message: string, action = 'X') {
    this.snackBar.open(message, action, {
      duration: 7000,
    })
  }

  /**
   * Makes sure the zip-file is downloaded to the local filesystem
   * @param response
   */
  private handleDownload(response: ZipDownload) {
    // Download zip-file with contents. Not the finest way, but this one always work according to SO
    const blob = new Blob([response.body], {
      type: 'application/zip',
    })

    const a: any = document.createElement('a')
    document.body.appendChild(a)
    a.style = 'display: none'
    const url = this.window.URL.createObjectURL(blob)
    a.href = url
    a.download = response.filename
    a.click()
    this.window.URL.revokeObjectURL(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-details/administration-documents-download/administration-documents-download.component.ts